"use client";

import { saveSettingsFieldAction } from "@/actions/admin";
import { ImageUpload } from "@/ui/image-upload/image-upload";

export const OGImage = ({ image }: { image: string | undefined }) => {
	return (
		<ImageUpload
			width={1200}
			height={630}
			images={[image]}
			maxImages={1}
			name="ogimage"
			// @todo this should not autosave on upload because it's inconsistent with how other images are handled
			onUpload={async (image) => {
				await saveSettingsFieldAction({
					fieldPath: "ogimage",
					value: JSON.stringify(image),
				});
			}}
			onDelete={async () => {
				await saveSettingsFieldAction({
					fieldPath: "ogimage",
					value: JSON.stringify(null),
				});
			}}
		/>
	);
};

export const LogoUpload = ({
	image,
	name,
	onUpload,
	onDelete,
}: {
	name: "logo" | "favicon";
	image: { imageUrl: string; width?: number | undefined; height?: number | undefined } | undefined;
	onUpload?: (imageUrl: string, args: { width: number; height: number }) => void;
	onDelete?: (imageUrl: string) => void;
}) => {
	return (
		<ImageUpload
			width={image?.width}
			height={image?.height}
			images={[image?.imageUrl]}
			maxImages={1}
			name={name}
			// @todo this should not autosave on upload because it's inconsistent with how other images are handled
			onUpload={async (imageUrl, { height, width }) => {
				onUpload?.(imageUrl, { width, height });
				await saveSettingsFieldAction({
					fieldPath: name,
					value: JSON.stringify({ imageUrl, width, height }),
				});
			}}
			onDelete={async (imageUrl) => {
				onDelete?.(imageUrl);
				await saveSettingsFieldAction({
					fieldPath: name,
					value: JSON.stringify(null),
				});
			}}
		/>
	);
};
